import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isString } from '@pct-ts/typeguard';

@Pipe({
  name: 'markSearchText',
})
export class MarkSearchTextPipe implements PipeTransform {
  transform(text: string, searchText: string): string {
    if (!isString(text) || !isString(searchText) || text.length === 0 || searchText.length === 0) {
      return text;
    }
    return text.replace(new RegExp(searchText, 'ugi'), '<b>$&</b>');
  }
}
